import { GetAgentByIdResponse, OrderAddressData } from "services/interface";
import styled from "@emotion/styled";
import { Col, Form, FormInstance, Row, Switch, Typography } from "antd";
import { Dispatch, FC, SetStateAction } from "react";
import RetailDescriptionForm from "./RetailDescriptionForm";
import RetailAddressForm from "./RetailAddressForm";

interface MainCreateRetailProps {
  form: FormInstance;
  masterProviceData: any;
  dataAddress?: OrderAddressData;
  showMobile?: boolean;
}

const MainCreateRetail: FC<MainCreateRetailProps> = ({
  form,
  masterProviceData,
  dataAddress,
  showMobile = false,
}) => {
  return (
    <>
      <FormWrapper>
        <FormItemWrapper>
          <HeadWrapper>
            <Typography.Text
              style={{
                fontWeight: 600,
              }}
              underline
            >
              ข้อมูลลูกค้า
            </Typography.Text>
          </HeadWrapper>
          <TextWrapper>
            {/* <Typography.Text>รูปภาพสินค้า</Typography.Text> */}
            <Form.Item
              label="VIP"
              name="is_vip"
              valuePropName="checked"
              // rules={[{ required: false, message: "กรุณากรอกชื่อสินค้า" }]}
              className="switch-form-item"
            >
              <Switch
              // onChange={(value) => {
              //   setCheckIsActive(value);
              // }}
              />
            </Form.Item>
          </TextWrapper>
          <Row style={{ backgroundColor: "#EFEFEFEF" }}>
            <Col span={12}>
              <RetailDescriptionForm form={form} showMobile={showMobile} />
            </Col>
            <Col span={12}>
              <RetailAddressForm
                form={form}
                is_active={false}
                masterProviceData={masterProviceData}
                dataAddress={dataAddress}
              />
            </Col>
          </Row>
        </FormItemWrapper>
      </FormWrapper>
    </>
  );
};

export default MainCreateRetail;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0px 10px 0px 10px;
`;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffffff;
`;

const FormItemWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px 0px 10px 0px;
  border-radius: 10px;
`;

const TextWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 10px 10px 0px 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;
